import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL || '';

const cache = {};

export default function useCustomFields(entity) {
    const { getAuthHeader } = useAuth();
    const [fields, setFields] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (!entity) { setLoading(false); return; }

        // Use cache if available
        if (cache[entity]) {
            setFields(cache[entity]);
            setLoading(false);
            return;
        }

        const load = async () => {
            try {
                const res = await axios.get(`${API}/api/admin/custom-fields`, {
                    headers: getAuthHeader(),
                    params: { entity },
                });
                const data = res.data || [];
                cache[entity] = data;
                setFields(data);
            } catch {
                setFields([]);
            }
            finally { setLoading(false); }
        };
        load();
    }, [entity, getAuthHeader]);

    const invalidateCache = () => {
        delete cache[entity];
    };

    return { fields, loading, invalidateCache };
}
